// extracted by mini-css-extract-plugin
export var card = "_mr-1";
export var summary = "_mr-0";
export var unreadDot = "_mr-2";